// extracted by mini-css-extract-plugin
export default {"appButton":"AppButton_appButton__D3fUK"};